export default function applyCondition<T>(items:T[], conditions: any[]) : T[] {

  if (conditions.length > 0 && items) {
    return items.filter((notification: any) => {
      return conditions.every((condition) => {
        return condition(notification);
      });
    });
  }
  return items;
}
